import React, { useEffect, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import SVGLandingNifty from '../../../assets/images/landing/nifty';
import SVGLandingHands from '../../../assets/images/landing/hands';
import Loader from '../../../components/general/loader';
import Button from '../../../components/controls/button';

interface Props {
  visible: boolean;
  error: boolean;
}

const AppLoader = ({ visible, error }: Props) => {
  const [exists, setExists] = useState(true);

  useEffect(() => {
    if (visible) {
      setExists(true);
      document.body.className = 'unscrollable';
    } else {
      setTimeout(() => {
        setExists(false);
        document.body.className = '';
      }, 1000);
    }
  }, [visible]);

  if (!exists) return null;

  return (
    <div className={clsx('app-loader', !visible && 'app-loader-hidden')}>
      <div className='app-loader-content'>
        <div className='app-loader-wording'>
          <SVGLandingNifty height={87} />
          <SVGLandingHands height={81} />
        </div>
        {/*<h1 className='app-loader-wording'>nifty hands</h1>*/}
        {error ? (
          <h4 className='app-loader-error'>
            Can't load certain content <br />
            Please refresh a page
          </h4>
        ) : (
          <Loader
            size='Min(130px, 30vw)'
            color='primary'
            className='app-loader-loader'
          />
        )}
        <Button
          variant='outlined'
          color='default'
          onClick={() => window.location.reload()}
          className={clsx('app-loader-refresh', error && 'visible')}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default AppLoader;
